import Layout from 'Nori/Layout';
import SplitContent from 'Custom/Split/SplitContent';
import Hero from 'Nori/Hero/HeroFull';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import RichText from 'Custom/RichText';
import AjustableImage from 'Custom/AjustableImage';
import styles from 'styles/pages/insuranceCoverage.module.scss';
import Container from 'Nori/Container';
import { Finder } from 'Custom/Finder';
import HERO_BG_IMAGE from 'Images/background/blue-bg.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/blue-bg-mobile.png';
import CIRCLE_IMAGE_DESKTOP from 'Images/misc/x-yellow-desktop.webp';
import CIRCLE_IMAGE_MOBILE from 'Images/misc/x-yellow-mobile.webp';
import CHECK_GOLD_DESKTOP from 'Images/misc/check-gold-desktop.webp';
import CHECK_GOLD_MOBILE from 'Images/misc/check-gold-mobile.webp';
import HeroQuestion from 'Custom/HeroQuestion';

const HEAD = {
  title:
    'Insurance Coverage For NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  description:
    'Explore insurance details for NEXPLANON® (etonogestrel implant) 68 mg Radiopaque and check with your insurance plan for coverage information.',
  keywords: 'Nexplanon Insurance Coverage, Is Nexplanon Covered by Insurance, Nexplanon Cost and Coverage',
};


const HeroBannerContent = () => {
  return (
    <div data-qa-tag="insurance-coverage-hero-content" className={styles['content-wrap']}>
      <RichText data-qa-tag="insurance-coverage-hero-content-wrapper">
        <div className={styles.insuranceCoveragePage}>
          <h4 data-qa-tag="insurance-coverage-hero-title">INSURANCE COVERAGE</h4>
          <p data-qa-tag="insurance-coverage-hero-desc-A" className={styles.middleHeroText}>how can you check if <span>Nexplanon</span> is covered?</p>
          <p data-qa-tag="insurance-coverage-hero-desc-B" className={styles.bottomHeroText}>
            Once you and your doctor have decided that NEXPLANON is right for you, check with your insurance provider to determine your specific coverage.

          </p>
          <p data-qa-tag="insurance-coverage-hero-bottom-desc" className={styles.bottomHeroText}>
            See how to determine if NEXPLANON is covered by your insurance plan below.
          </p>
        </div>
      </RichText>
    </div>
  );
};

export default function InsuranceCoverage() {
  return (
    <Layout head={HEAD}>
      <div data-qa-tag="insurance-coverage-hero-section" className={styles.heroWrapper}>
        <ItemBreakpoint breakpoint={'lg'}>
          <Hero image={HERO_BG_IMAGE} data-qa-tag="insurance-coverage-hero-image-desktop">
            <HeroBannerContent></HeroBannerContent>
          </Hero>
          <Hero image={HERO_BG_IMAGE_MOBILE} data-qa-tag="insurance-coverage-hero-image-mobile">
            <HeroBannerContent></HeroBannerContent>
          </Hero>
        </ItemBreakpoint>
      </div>

      <section
        data-qa-tag="insurance-coverage-customer-split"
        className={styles.copyBlock}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="is NEXPLANON covered by your insurance?"
        data-design-module_no="02"
      >
        <Container size="md" data-qa-tag="insurance-coverage-customer-container">
          <RichText data-qa-tag="insurance-coverage-customer-content" className={styles.mdCopy}>
            <h2 data-qa-tag="insurance-coverage-customer-title" className="mb">Is NEXPLANON covered by your insurance?</h2>
            <p data-qa-tag="insurance-coverage-customer-description" className="intro">
              NEXPLANON may be covered as a medical benefit or as a pharmacy benefit. To find out if you have coverage for NEXPLANON as a medical benefit:
            </p>
          </RichText>
        </Container>
        <Container data-qa-tag="insurance-coverage-customer-container-B">
          <RichText className={styles.columns} data-qa-tag="insurance-coverage-content-B">
            <div>
              <h3 data-qa-tag="insurance-coverage-title-call">Call the customer service for your insurance</h3>
              <p data-qa-tag="insurance-coverage-desc-call" className='body-text'>
                That number should be listed on the back of your health insurance card. Be sure to ask for the names of any people you speak with and write them down.
              </p>
            </div>
            <div>
              <h3 data-qa-tag="insurance-coverage-title-inform">Inform the representative about NEXPLANON</h3>
              <p data-qa-tag="insurance-coverage-desc-physician" className="body-text">
                Tell them NEXPLANON is a physician-administered birth control drug (not a device) and that your physician will:
              </p>
              <ul data-qa-tag="insurance-coverage-list" className={`${styles.list} primary`}>
                <li data-qa-tag="insurance-coverage-list-item-A">Prescribe NEXPLANON</li>
                <li data-qa-tag="insurance-coverage-list-item-B">Order NEXPLANON for you</li>
                <li data-qa-tag="insurance-coverage-list-item-C">Insert NEXPLANON during an office visit</li>
              </ul>
            </div>
            <div>
              <h3 data-qa-tag="insurance-coverage-title-ask">Ask if NEXPLANON is covered by your insurance</h3>
              <p data-qa-tag="insurance-coverage-desc-answer" className='body-text'>
                If the answer is no, then ask if you have coverage for NEXPLANON in your pharmacy benefit.
              </p>
              <p data-qa-tag="insurance-coverage-desc-info" className='body-text'>
                To get information about pharmacy benefits, you may have to call another number. If so, repeat these steps with the pharmacy benefit representative.
              </p>
            </div>
          </RichText>
        </Container>
      </section>

      <SplitContent
        data-qa-tag="insurance-coverage-gold-split"
        reverse
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="if NEXPLANON is covered"
        data-design-module_no="03"
      >
        <ItemBreakpoint breakpoint='md'>
          <AjustableImage
            data-qa-tag="insurance-coverage-gold-image-desktop"
            size="full"
            image={{ src: CHECK_GOLD_DESKTOP, style: { width: 292 }, alt: '' }}
          />
          <AjustableImage
            data-qa-tag="insurance-coverage-gold-image-mobile"
            size="full"
            image={{ src: CHECK_GOLD_MOBILE, alt: '' }}
          />
        </ItemBreakpoint>
        <>
          <RichText data-qa-tag="insurance-coverage-gold-content" className={styles.copy}>
            <h2 data-qa-tag="insurance-coverage-gold-title-covered" className="mb">If NEXPLANON is covered</h2>

            <p data-qa-tag="insurance-coverage-gold-description-covered" className="intro">
              You will want to verify some information with your insurance company to better understand your costs.
            </p>

            <h3 data-qa-tag="insurance-coverage-gold-procedure">Ask if NEXPLANON and the procedure are 100% covered</h3>
            <div data-qa-tag="insurance-coverage-gold-pocket" className="body-text">
              <p className="mt">If not, ask about any out-of-pocket costs.

              </p>
              <p className="mt-2">
                You should also confirm about the coverage and out-of-pocket costs for removal.
              </p>
              <p className="mt-2">Keep in mind your insurance may change.</p>
            </div>

            <h3 data-qa-tag="insurance-coverage-gold-verification">Ask for verification of coverage</h3>
            <p className="body-text" data-qa-tag="insurance-coverage-gold-beneficial">
              This step could be beneficial if for any reason a claim gets
              denied.
            </p>
            <h3 data-qa-tag="insurance-coverage-gold-written">If written verification isn’t available</h3>
            <p data-qa-tag="insurance-coverage-gold-healthcare" className="body-text">
              Make sure you get the name of the person you spoke with, and
              communicate with your healthcare professional what you learned
              about your coverage.
            </p>
            <h3 data-qa-tag="insurance-coverage-gold-appointment">Make an appointment</h3>
            <p data-qa-tag="insurance-coverage-gold-birth" className="body-text">
              During this appointment, you will have your NEXPLANON birth
              control inserted in your arm.
            </p>
          </RichText>

        </>
      </SplitContent>


      <SplitContent
        data-qa-tag="insurance-coverage-circle-split"
        backgroundColor={'colored'}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="if NEXPLANON isn’t covered"
        data-design-module_no="04"
      >
        <ItemBreakpoint breakpoint='md'>
          <AjustableImage
            data-qa-tag="insurance-coverage-circle-image-desktop"
            size="full"
            image={{ src: CIRCLE_IMAGE_DESKTOP, style: { width: 292 }, alt: '' }}
          />
          <AjustableImage
            data-qa-tag="insurance-coverage-circle-image-mobile"
            size="full"
            image={{ src: CIRCLE_IMAGE_MOBILE, alt: '' }}
          />
        </ItemBreakpoint>
        <>
          <RichText data-qa-tag="insurance-coverage-circle-content" className={styles.copy}>
            <h2 data-qa-tag="insurance-coverage-circle-covered">If NEXPLANON isn’t covered</h2>
            <p className="intro" data-qa-tag="insurance-coverage-circle-options">You may have some other options.</p>
            <h3 data-qa-tag="insurance-coverage-circle-expectations">Ask if there are “Medical Exceptions” available</h3>
            <p data-qa-tag="insurance-coverage-circle-treatment" className="body-text">
              Some policies have medical exception clauses that allow your
              healthcare professional to authorize a specific treatment.
            </p>
            <h3 data-qa-tag="insurance-coverage-circle-exception">If a “Medical Exception” isn’t available</h3>
            <p data-qa-tag="insurance-coverage-circle-payment" className="body-text">
              Ask your healthcare professional if they have any payment plans
              available to offset the cost.
            </p>
          </RichText>
        </>
      </SplitContent>

      <HeroQuestion data-qa-tag="insurance-coverage-hero-question"></HeroQuestion>

      <Finder data-design-module_no="06" />
    </Layout>
  );
}
